<template>
    <div class="position-relative d-flex justify-center">
        <img :src="topImg" alt="" class="podio-img" />
        <div class="position-absolute first-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ first.points }}</span></v-btn
                >
                <div class="first-avatar">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${first.avatar.name}/${first.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all mb-10"
                    />
                </div>
                <div class="first-number white--text">1</div>
                <div class="first-name white--text text-capitalize">{{ setName(first) }}</div>
            </div>
        </div>
        <div class="position-absolute second-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ second.points }}</span></v-btn
                >
                <div class="second-avatar">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${second.avatar.name}/${second.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all"
                    />
                </div>
                <div class="second-number white--text">2</div>
                <div class="second-name white--text">{{ setName(second) }}</div>
            </div>
        </div>
        <div class="position-absolute third-content">
            <div class="position-relative d-flex justify-center align-center flex-column">
                <v-btn class="point-banner position-absolute px-9" color="#dad2f4"
                    ><span>{{ third.points }}</span></v-btn
                >
                <div class="third-avatar">
                    <img
                        :src="`https://assets.beereaders.com/avatar/${third.avatar.name}/${third.avatar.value}`"
                        alt="Avatar"
                        height="150"
                        width="150"
                        class="transition-all"
                    />
                </div>
                <div class="third-number white--text">3</div>
                <div class="third-name white--text">{{ setName(third) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        first: { type: Object, default: null },
        second: { type: Object, default: null },
        third: { type: Object, default: null },
    },
    data() {
        return { topImg: require('@/assets/img/illustrations/ranking.svg') }
    },
    methods: {
        setName(data) {
            return `${this.capitalizeText(data.firstName.split(' ')[0])} ${this.capitalizeText(
                data.lastName.split(' ')[0]
            )}`
        },
        capitalizeText(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
        },
    },
}
</script>
<style>
.first-content {
    margin-left: -3vh;
}
.second-content {
    transform: rotate(-5deg);
}

.third-content {
    transform: rotate(5deg);
}

.point-banner {
    top: -5vh;
    border-radius: 7px;
    color: #514773;
}

.third-content .point-banner {
    top: 1vh !important;
    right: -4vh;
}

.second-content .point-banner {
    top: 1vh !important;
    left: -4vh;
}

.point-banner span {
    color: #514773;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
    font-size: 18px;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .podio-img {
        width: 95vh;
        /* max-width: 100vh; */
    }

    .first-content {
        top: 15vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 25vh;
        left: 7.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 25vh;
        right: 10vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .podio-img {
        width: 110vh;
        /* max-width: 80vh; */
    }

    .first-content {
        top: 20vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 40vh;
        left: 12.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 40vh;
        right: 15vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .podio-img {
        width: 45vw;
        /* max-width: 80vh; */
    }

    .first-content {
        top: 15vh;
        width: 97.5%;
    }
    .first-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .second-content {
        top: 27vh;
        left: 7.5vh;
    }
    .second-number {
        font-weight: bolder;
        font-size: 86px;
    }

    .third-content {
        top: 28vh;
        right: 10vh;
    }
    .third-number {
        font-weight: bolder;
        font-size: 86px;
    }
}
</style>
